function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFA200",
  fillRule: "evenodd",
  d: "M17.5,11 L17.7,11 C17.9,10.5 18,10 18,9.5 C18,8.5 17.5,7.5 16.8,6.9 C16.3,5.2 14.8,4 13,4 C12.9,4 12.8,4 12.7,4 C12.1,2.8 10.9,2 9.5,2 C8.1,2 6.9,2.8 6.3,4 C6.2,4 6.1,4 6,4 C3.8,4 2,5.8 2,8 C2,9.2 2.5,10.3 3.4,11 L2.5,11 C2.2,11 2,11.2 2,11.5 C2.2,13.9 3.8,15.9 6,16.6 L6,17 C6,17.6 6.5,18 7,18 L13,18 C13.6,18 14,17.6 14,17 L14,16.6 C16.2,15.8 17.8,13.9 18,11.5 C18,11.2 17.8,11 17.5,11 Z M17,9.5 C17,10 16.8,10.6 16.5,11 L12.5,11 C12.2,10.6 12,10 12,9.5 C12,8.1 13.1,7 14.5,7 C15.9,7 17,8.1 17,9.5 Z M3,8 C3,6.9 3.7,4.7 7,5 C7.9,3 9,3 9.5,3 C9.9,3 11.1,3 12,5 C13.1,4.9 14.4,5 15.3,6.1 C15,6 14.8,6 14.5,6 C12.6,6 11,7.6 11,9.5 C11,10 11.1,10.5 11.3,11 L10,11 L10,5.2 C10,5.1 9.9,5 9.7,5 L9.2,5 C9.1,5 9,5.1 9,5.2 L9,10.2 L5.5,6.8 C5.4,6.7 5.2,6.7 5.1,6.8 L4.8,7.2 C4.7,7.3 4.7,7.5 4.8,7.6 L8.3,11 L6,11 C4.3,11 3,9.7 3,8 Z"
});

var SvgSalad = function SvgSalad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSalad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/salad.28fbc5f3.svg";
export { ForwardRef as ReactComponent };